<template>
  <div class="containerNoticia">
    <el-row>
      <el-col :span="24">
        <div class="title">{{ $t('NOTICIAS_nueva_noticia') }}</div>
      </el-col>
    </el-row>

    <el-row>
    <el-col :span="23">

    <el-card>
      <div class="card_body">
         
          <el-row>
            <el-col :span="24">
              <div class="field">
                <div class="label">{{ $t('NOTICIAS_titulo') }}</div>
                <el-input 
                class="input" 
                size="small"
                :value="noticia.titulo"
                v-model="noticia.titulo" />
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="field">
                <div class="label">{{ $t('NOTICIAS_copete') }}</div>
                <el-input class="textarea" 
                type="textarea" 
                :value="noticia.copete"
                :rows="2" 
                v-model="noticia.copete" />
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="field">
                <div class="label">{{ $t('NOTICIAS_cuerpo') }}</div>
                <el-input class="textarea" 
                type="textarea" 
                :rows="4" 
                :value="noticia.cuerpo"
                v-model="noticia.cuerpo" />
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="field">
                <div class="label">{{ $t('NOTICIAS_imagen_principal') }}</div>
                <FileUpload 
                  style="text-align:left !important;"
                  name="noticia"
                  :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                  :limit="1"
                  :files="imagenes"
                  :storeAction="'gestionNoticias/uploadImagen'"
                  :onFileListChange="onImagenesChanged" 
                  :temporalId="idTemporal"
                />         
              </div>
            </el-col>
          </el-row>

        </div>
    </el-card>
    </el-col>
    </el-row>


    <div class="btnContainer">
      <el-button type="primary" 
      @click="save" 
      :loading="guardado">{{ $t('GENERAL_saveBtn') }}</el-button>
      <router-link :to="{ name: 'Gestion Noticias', params: { keepFilter: true }}">
        <el-button>{{ $t('GENERAL_cancelBtn') }}</el-button>    
      </router-link>
    </div>
  </div>
</template>

<script>
import FileUpload from '../FileUpload/index'
import { mapState } from 'vuex'
import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado'
import { showError, showSuccess } from '../Mensaje'

export default {
  name: 'AltaEdicionNoticia',
  components: { FileUpload },
  data() {
    return {
      esEdicion: false,
      noticia: {
        id: 0,
        idEstadoNoticia: 1,
        titulo: "",
        copete: "",
        cuerpo: "",
        fechaRegistro: null,
      },
      imagenes: [],
      idTemporal: new Date().getTime().toString(),
      guardado: false,
      loading: false
    }
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      nombreCompleto: state => state.sesion.resultadoAutenticacion.NombreCompleto
    }),
  },
  methods: {

    cargarNoticia(noticia) {

      // cargo la solicitud a editar
      this.noticia.titulo = noticia.Titulo;
      this.noticia.copete = noticia.Copete;
      this.noticia.cuerpo = noticia.Cuerpo;
      this.noticia.fechaRegistro = noticia.FechaRegistro;
      this.noticia.id = noticia.Id;
      this.noticia.idEstadoNoticia = noticia.EstadoNoticia.Id !== 3 ? noticia.EstadoNoticia.Id : 1
      
      // cargar imagen
      if (noticia.PathImagen) {
        this.imagenes = [{name: noticia.FileNameImagen}];
      }
    },
    onImagenesChanged(name, fileUpload) {
      this.imagenes = [{name: fileUpload[0].name}]

    },

   
    save() {
      // indico que se está guardado la noticia
      this.guardado = true
      
      // validaciones
      let valida = true

      if(!this.noticia.titulo) {
        showError(this.$t('NOTICIAS_titulo_missing'))
        valida = false
      }

      if(!this.noticia.copete) {
        showError(this.$t('NOTICIAS_copete_missing'))
        valida = false
      }

      if(!this.noticia.cuerpo) {
        showError(this.$t('NOTICIAS_cuerpo_missing'))
        valida = false
      }

      if (this.imagenes.name == "") {
        showError(this.$t("ARCHIVOS_archivo_missing"));
        valida = false;
      }

      if(!valida) {
        this.guardado = false
        return
      }

      // armo el payload
      let payload = {
        Id: this.noticia.id,
        IdEstadoNoticia: this.noticia.idEstadoNoticia,
        IdUsuario: this.idUsuario,
        NombreUsuario: this.nombreCompleto,
        Titulo: this.noticia.titulo,
        Copete: this.noticia.copete,
        Cuerpo: this.noticia.cuerpo,
        PathImagen: this.imagenes.length > 0 ? this.imagenes[0].name : '',
        IdCarpetaTemporal: this.idTemporal, 
        FechaRegistro: this.noticia.fechaRegistro,
      }
      // persisto la noticia      
      this.$store.dispatch('gestionNoticias/saveNoticia', payload)
      .then(codigoResultado => 
      {
        if(codigoResultado > 0)
        {
          showSuccess(this.$t('NOTICIAS_success'));
          if(this.esEdicion)
            this.$router.push({ name: 'Gestion Noticias', params: {keepFilter: true}});
          else
            this.$router.push({ name: 'Gestion Noticias', params: {
              idNuevaNoticia: codigoResultado
              }})
        }
        else
          mostrarMensajeInternacionalizado(codigoResultado)
      })
      .finally(() => this.guardado = false);
    },
  },

    mounted() {

    if (this.$route.params.id) {
      // indico que es una edición de Noticia
      this.esEdicion = true;

      // busco la Noticia a editar
      this.$store
      
        .dispatch("gestionNoticias/getNoticia", {
          id: this.$route.params.id,
        })
        .then(data => {
          this.cargarNoticia(data);
        });

    }
  }
  
};
</script>

<style scoped>
.containerNoticia {
  display: inline-block;
  padding: 0 30px;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
}
.card_body {
  text-align: left;
}
.title {
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0 0 20px;
  padding: 0 0 7px;
}

.field {
  padding: 0 8px;
}
.label {
  font-size: 14px;
  text-align: left;
  margin: 15px 0 4px;

}
.input {
  box-sizing: border-box;
  display: inline-block;
  outline: 0;
}
.textarea {
  border-radius: 4px;
  min-height: 90px;
}
.imagen {
  vertical-align: top;
}
.btnContainer {
  margin-top: 30px;
}

  @media(max-width: 600px) {

    .containerNoticia {
     padding: 2px 5px;
    }
  }
</style>